import React from 'react';

// Phone number formatting utility
export const formatPhoneNumber = (value: string): string => {
  // Remove all non-digits
  const phoneNumber = value.replace(/\D/g, '');
  
  // Format based on length
  if (phoneNumber.length <= 3) {
    return phoneNumber;
  } else if (phoneNumber.length <= 6) {
    return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3)}`;
  } else if (phoneNumber.length <= 10) {
    return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3, 6)}-${phoneNumber.slice(6)}`;
  } else {
    // Handle 11+ digits (with country code)
    return `+${phoneNumber.slice(0, 1)} (${phoneNumber.slice(1, 4)}) ${phoneNumber.slice(4, 7)}-${phoneNumber.slice(7, 11)}`;
  }
};

export const unformatPhoneNumber = (value: string): string => {
  return value.replace(/\D/g, '');
};

// Phone input component with auto-formatting
export interface PhoneInputProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  className?: string;
  style?: React.CSSProperties;
}

export const PhoneInput: React.FC<PhoneInputProps> = ({ 
  value, 
  onChange, 
  placeholder, 
  className, 
  style 
}) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const inputValue = e.target.value;
    const formatted = formatPhoneNumber(inputValue);
    onChange(formatted);
  };

  const handleBlur = () => {
    // Ensure proper formatting when leaving the field
    if (value && value.replace(/\D/g, '').length >= 10) {
      const formatted = formatPhoneNumber(value);
      onChange(formatted);
    }
  };

  return (
    <input
      type="tel"
      value={value}
      onChange={handleChange}
      onBlur={handleBlur}
      placeholder={placeholder || "(555) 123-4567"}
      className={className}
      style={style}
      maxLength={20}
    />
  );
};

